'use es6';

const StandardErrorSubCategory = {
  THIRD_PARTY_OUTAGE: 'IntegrationResponse.THIRD_PARTY_OUTAGE'
};
export default StandardErrorSubCategory;